const layout = {
  sideBar: {
    menu: {
      more: {
        children: {
          shifts: 'Horário de trabalho',
        },
      },
    },
  },
};

export default layout;
